import { Droppable, DroppableProvided } from 'react-beautiful-dnd';
import { Add } from '@mui/icons-material';
import { Button, List } from '@mui/material';
import { ICustomSubNavigationDetail } from '../../../models';
import { SortableSubNavItem } from './SortableSubNavItem';
import { getSecuritySensitiveRandomNumber } from '../../../helpers';

interface ISortableNavSubContainer {
  navItems: ICustomSubNavigationDetail[];
  subLinks: ICustomSubNavigationDetail[];
  item: ICustomSubNavigationDetail;
  isNavExpanded: {
    [item: string]: boolean;
  };
  setNavExpanded: (val: { [item: string]: boolean }) => void;
  setNavItems: (navItems: ICustomSubNavigationDetail[]) => void;
  isEditing: {
    [id: string]: boolean;
  };
  setEditing: (val: { [id: number]: boolean }) => void;
  originalNavItems: ICustomSubNavigationDetail[];
}

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? `#e1e1e1` : '#fff',
  padding: isDraggingOver ? '8px' : 0,
  margin: isDraggingOver ? '5px 0' : 0
});

export const SortableNavSubContainer = ({
  isNavExpanded,
  setNavExpanded,
  originalNavItems,
  isEditing,
  setEditing,
  item,
  subLinks,
  navItems,
  setNavItems
}: ISortableNavSubContainer) => {
  return (
    <Droppable key={item.customNavigationId} droppableId={`${item.customNavigationId}`} type="droppableSubItem">
      {(provided: DroppableProvided, snapshot) => {
        return (
          <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
            <List component="div" disablePadding>
              {subLinks &&
                subLinks.map((subItem, index) => {
                  return (
                    <SortableSubNavItem
                      key={subItem.customNavigationId}
                      originalNavItems={originalNavItems}
                      isEditing={isEditing}
                      setEditing={setEditing}
                      item={item}
                      navItems={navItems}
                      setNavItems={setNavItems}
                      index={index}
                      subItem={subItem}
                      setNavExpanded={setNavExpanded}
                      isNavExpanded={isNavExpanded}
                    />
                  );
                })}
            </List>
            {!snapshot.isDraggingOver && item?.subNavigation?.length !== 0 && (
              <Button
                color="secondary"
                startIcon={<Add />}
                sx={{ fontSize: '12px', padding: '0', marginLeft: '1rem' }}
                onClick={() => {
                  const copy = JSON.parse(JSON.stringify(navItems));
                  const parentIndex = navItems.findIndex(i => i.customNavigationId === item.customNavigationId);
                  const randomNumber = Math.floor(getSecuritySensitiveRandomNumber() * (100000 - 1 + 1) + 1);
                  copy[parentIndex].subNavigation.push({
                    customNavigationId: randomNumber,
                    name: 'New Sub Nav',
                    url: 'url',
                    isNew: true,
                    sortOrder: copy[parentIndex].subNavigation.length + 1
                  });
                  setEditing({
                    [randomNumber]: true
                  });
                  setNavItems(copy);
                }}
              >
                Add Child Nav Item
              </Button>
            )}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};
